import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { authenticationStatus, useAuth } from '../contexts/auth.context';
import { FullPageLoader } from '../components/loaders/FullPageLoader';
import { LOGIN_ROUTE } from './constants';

const ProtectedRoute = ({ isRequireAuth, ...props }) => {
    const { user, isAuthentication, status } = useAuth();
    
    // if (isAuthentication) {
    if (status === authenticationStatus.AUTHENTICATING) {
        return <FullPageLoader />
    }
    
    if (isRequireAuth && !user) {
        const returnTo = encodeURIComponent(window.location.pathname);
        
        return <Redirect to={`${LOGIN_ROUTE}?returnTo=${returnTo}`} />;
    }
    
    return (
        <Route {...props} />
    );
};

export { ProtectedRoute };
